import React from 'react';
import { useTranslation } from 'react-i18next';
import AddCircleOutlineRounded from '@mui/icons-material/AddCircleOutlineRounded';
import { Box, IconButton, Stack } from '@mui/material';
import { useSetAtom } from 'jotai';

import { createNewActionSelector } from '../Action/atoms';

import { styles } from './index.styles';

export const CREATE_ACTION_BUTTON_TEST_ID = 'create-action-button';

const CreateActionButton = () => {
  const { t } = useTranslation('planAction');
  const createNewAction = useSetAtom(createNewActionSelector);

  return (
    <Box data-test-id={CREATE_ACTION_BUTTON_TEST_ID}>
      <Box sx={styles.header}>{t('ActionPlan.CreateNewAction')}</Box>
      <Stack direction="row" sx={styles.content}>
        <IconButton size="large" onClick={() => createNewAction()}>
          <AddCircleOutlineRounded fontSize="large" color="primary" />
        </IconButton>
      </Stack>
    </Box>
  );
};

export default CreateActionButton;
